var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-number-input"},[_c('input',{staticClass:"input-bordered",attrs:{"placeholder":_vm.label,"min":"0","required":"","type":"number"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('update', { value: $event.target.valueAsNumber })}}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"focus-border"},[_c('i')])
}]

export { render, staticRenderFns }